$(document).ready(function()
{


    $(".go-to-tab").click(function(e) 
    {
        e.preventDefault();

        let target_tab = $(this).data('target-tab');
        let scroll_to = $(this).data('scroll-to');
        let scroll_finish = getAbsolutePosition($(scroll_to)); 
        let chosen_el = document.querySelector(target_tab);
        let chosen_tab = new bootstrap.Tab(chosen_el);

        chosen_tab.show();


        $('html, body').animate({
            scrollTop: ( scroll_finish  - 100 )
        },500);  

    });


    function getAbsolutePosition(element) 
    {
        let offset = element.offset();
        if (offset)
        {
            return offset.top;
        }
        return 0;
    }



});